import { LoggerClient } from '../services/logger.client';

export class LogController {
  static readonly getLogs = async () => {
    return await LoggerClient.getLogs();
  };
}
